import { jwtDecode } from "jwt-decode";
import _ from "lodash";
import { getToken } from "services/token-provider";
import { LocalStorageKeys, UserRoles } from "../types/enums";
//API calls should be in actions and not reducers. Reducer is only for chagning state.

export const SET_ORGANIZATION_USERS = "SET_ORGANIZATION_USERS";

export const setOrganizationUsers = (orgUsers) => {
  return {
    type: SET_ORGANIZATION_USERS,
    organizationUsers: orgUsers,
  };
};

export function getName() {
  return localStorage.getItem(LocalStorageKeys.NameId) ?? "";
}

export function hasOrganizationUserId() {
  return localStorage.getItem(LocalStorageKeys.OrganizationUserId)
    ? true
    : false;
}

export async function getUserId() {
  const token = await getToken();
  if (!token) return "";
  const decodedToken = jwtDecode(token);
  return decodedToken.userId;
}
export function getOrganizationUserId() {
  return localStorage.getItem(LocalStorageKeys.OrganizationUserId);
}

function getUserRoles() {
  let userRoles = localStorage.getItem(LocalStorageKeys.UserRoles);
  if (!userRoles) {
    userRoles = ["none"];
  } else {
    userRoles = _.split(userRoles, ",").map((role) => role.trim());
  }
  return userRoles;
}

export function roleMatch(allowedRoles) {
  if (!allowedRoles) return true;
  let isRoleMatch = false;
  const userRoles = getUserRoles();
  allowedRoles.forEach((element) => {
    if (userRoles.includes(element)) {
      isRoleMatch = true;
    }
  });
  return isRoleMatch;
}

export function hasAnyEventRole() {
  const allowedRoles = [
    UserRoles.EventsAdministrator,
    UserRoles.EventsEditor,
    UserRoles.EventsContributor,
    UserRoles.EventsViewer,
  ];
  let isRoleMatch = false;
  const userRoles = getUserRoles();

  allowedRoles.forEach((element) => {
    if (userRoles.includes(element)) {
      isRoleMatch = true;
    }
  });
  return isRoleMatch;
}

export function hasAnyMonitoringRole() {
  const allowedRoles = [
    UserRoles.MonitoringAdministrator,
    UserRoles.MonitoringEditor,
    UserRoles.MonitoringViewer,
  ];
  let isRoleMatch = false;
  const userRoles = getUserRoles();

  allowedRoles.forEach((element) => {
    if (userRoles.includes(element)) {
      isRoleMatch = true;
    }
  });
  return isRoleMatch;
}
